import * as React from "react";

function SvgSmile(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M256 0C114.844 0 0 114.844 0 256s114.844 256 256 256 256-114.844 256-256S397.156 0 256 0zm0 490.667C126.604 490.667 21.333 385.396 21.333 256S126.604 21.333 256 21.333 490.667 126.604 490.667 256 385.396 490.667 256 490.667z" />
      <path d="M393.385 299.115a10.62 10.62 0 00-12.844 7.906c-13.75 57.885-64.958 98.313-124.542 98.313-59.656 0-110.885-40.49-124.573-98.448-1.365-5.75-7.146-9.24-12.833-7.938-5.74 1.354-9.292 7.104-7.938 12.833 15.979 67.646 75.75 114.885 145.344 114.885 69.51 0 129.26-47.167 145.292-114.708 1.365-5.739-2.176-11.489-7.906-12.843z" />
      <circle cx={170.667} cy={192} r={21.333} />
      <circle cx={341.333} cy={192} r={21.333} />
    </svg>
  );
}

export default SvgSmile;
